import SEO from "../../components/Common/SEO";
import CTASection from "../Home/CTABanner";
import FAQSection from "../Home/FAQSection";
import HowItWorks from "../Home/HowItWork";
import StatsSection from "../Home/StatsSection";
import WhyChooseUs from "../Home/WhyChooseUs";
import ContactHero from "./ContactHero";
import ContactLocation from "./ContactLocation";

const Contact = () => {
  return (
    <>
      <SEO page="contact" />
      <ContactHero />
      <ContactLocation />
      <HowItWorks />
      <StatsSection />
      <WhyChooseUs />
      <FAQSection />
      <CTASection />
    </>
  );
};

export default Contact;
